import type React from 'react';

import type { Client } from '@shared/types/users';
import { Avatar } from '@shared/ui/avatar';

interface Props {
	client: Client;
	size?: 'sm' | 'md';
}

export const ClientAvatar: React.FC<Props> = ({ client, size = 'sm' }) => {
	return client && <Avatar size={size} src={client.photo} />;
};
